import { Key } from "../../../models";
import { Actions, createNamespace } from "../../../flux/Actions";
import { SequenceState, IDataSet } from "../../Data";

const ns = createNamespace('TimeSeries');
export const names = {
    SET_DATA_SETS: ns('SET_DATA_SETS'),
    SET_RANGE: ns('SET_RANGE'),
    SET_TOOLTIP_TIME: ns('SET_TOOLTIP_TIME'),
    
    TOGGLE_VISIBILITY: ns('TOGGLE_VISIBILITY'),
    HIGHLIGHT_SINGLE: ns('HIGHLIGHT_SINGLE'),
    NORMALIZE: ns('NORMALIZE'),
};

export class TimeSeriesActions extends Actions
{
    setDataSets = (dataSets: IDataSet[]) => this.dispatch<IDataSet[]>(names.SET_DATA_SETS, dataSets);
    setRange = (range: [Date, Date]) => this.dispatch(names.SET_RANGE, range);
    setTooltipTime = (t: Date) => this.dispatch(names.SET_TOOLTIP_TIME, t);

    toggleVisibility = (sequenceId: Key) => this.dispatch<Key>(names.TOGGLE_VISIBILITY, sequenceId);
    highlightSingle = (sequenceId: Key) => this.dispatch<Key>(names.HIGHLIGHT_SINGLE, sequenceId);
    normalize = () => this.dispatch(names.NORMALIZE);
}


// WEBPACK FOOTER //
// ./src/charts/TimeSeries/flux/TimeSeriesActions.ts